import React from 'react';
import { Chip } from '@mui/material';
import { renderLeadStatus, renderTaskStatus, renderPriorityDesirabilityColor } from '../Utility/apiHelper';
import { handleValidateCodevalue } from '../Utility/constant';

const StatusChip = React.memo(function StatusChip({
  status,
  systemLookup,
  internationalise,
  isLead,
  chipType = "status"
}) {
  if (!status) return null;

  let chipStyle = {};
  if (chipType === "status") {
      chipStyle = isLead ? renderLeadStatus(systemLookup) : renderTaskStatus(systemLookup);
  } else if (chipType === "desirability" || chipType === "priority") {
      chipStyle = isLead ? renderPriorityDesirabilityColor(systemLookup) :  renderPriorityDesirabilityColor(status);
  }

  return (
    <Chip
      size="medium"
      sx={chipStyle}
      variant="outlined"
      label={handleValidateCodevalue(internationalise, status)}
    />
  );
});

export default StatusChip;
